const normalizeNumber = (value) => {
  const num = Number(value)
  return Number.isFinite(num) ? num : null
}

export const getReminderNextSteps = (recommendation, currentDate = new Date()) => {
  const basePlan = {
    postponeMonth: null,
    shouldPostpone: false,
    shouldComplete: false,
    postponeBeforeComplete: true,
    logMessage: '',
  }

  if (!recommendation) {
    return { ...basePlan, logMessage: 'No recommendation payload provided.' }
  }

  const expectedRaw = normalizeNumber(recommendation.expecteddate)
  const period = normalizeNumber(recommendation.period)
  const dueDate = normalizeNumber(recommendation.duedate)

  if (period === null) {
    return {
      ...basePlan,
      shouldComplete: true,
      postponeBeforeComplete: false,
      logMessage: 'Missing period value; completing reminder without postpone.',
    }
  }

  if (expectedRaw === null) {
    return {
      ...basePlan,
      shouldComplete: true,
      postponeBeforeComplete: false,
      logMessage: 'Invalid expected date; completing reminder without postpone.',
    }
  }

  if (expectedRaw === 0) {
    const monthNow = normalizeNumber(currentDate.getMonth() + 1) || 1
    let nextMonth = monthNow + period
    if (nextMonth > 12) {
      nextMonth -= 12
      return {
        postponeMonth: nextMonth,
        shouldPostpone: false,
        shouldComplete: true,
        postponeBeforeComplete: false,
        logMessage: 'New reminder spills into next year; completing directly.',
      }
    }
    return {
      postponeMonth: nextMonth,
      shouldPostpone: true,
      shouldComplete: false,
      postponeBeforeComplete: false,
      logMessage: 'New reminder initialised with postponed month.',
    }
  }

  const nextDue = expectedRaw + period
  if (nextDue > 12) {
    return {
      postponeMonth: dueDate ?? ((nextDue - 1) % 12) + 1,
      shouldPostpone: true,
      shouldComplete: true,
      postponeBeforeComplete: true,
      logMessage: 'Existing reminder postponed across year boundary.',
    }
  }

  return {
    postponeMonth: nextDue,
    shouldPostpone: true,
    shouldComplete: false,
    postponeBeforeComplete: false,
    logMessage: 'Existing reminder postponed within current year.',
  }
}

export default getReminderNextSteps
